import { createSelector } from 'reselect'
import shouldShowModalPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/should-show-modal'
import shouldShowBannerPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/should-show-banner'
import shouldShowModalOrBannerPostSampleSelectUtil from 'modules/post-sample-survey/redux/selectors/should-show-modal-or-banner/utils'

const shouldShowModalOrBannerPostSampleSelect = createSelector(
  shouldShowBannerPostSampleSurveySelect,
  shouldShowModalPostSampleSurveySelect,
  (shouldShowBanner, shouldShowModal) => shouldShowModalOrBannerPostSampleSelectUtil({
    shouldShowBanner,
    shouldShowModal
  })
)
export default shouldShowModalOrBannerPostSampleSelect
